import { createReducer } from '@reduxjs/toolkit'
import { ShowModalType } from '@/scenes/engine/common/constants'
import { setShowModalType, setCustomTextModal, setWhatsNewData } from './action'

export interface ModalCustomTextProps {
  header: string
  text: string
  primaryButtonText?: string
  secondaryButtonText?: string
  showSecondaryButton?: boolean
  callbackGeneration?: number
  primaryButtonVariant?: 'default' | 'gradient' | 'super-gradient'
}

export interface ModalState {
  showModalType: ShowModalType | null
  customTextProps: ModalCustomTextProps | null
  whatsNewData: any[] | null
}

const initialState: ModalState = {
  showModalType: null,
  customTextProps: null,
  whatsNewData: null,
}

export const modalReducer = createReducer(initialState, builder => {
  builder
    .addCase(setShowModalType, (state, { payload }) => {
      state.showModalType = payload
      state.customTextProps = null
    })
    .addCase(setCustomTextModal, (state, { payload }) => {
      state.showModalType = ShowModalType.CUSTOM_TEXT
      state.customTextProps = payload
    })
    .addCase(setWhatsNewData, (state, { payload }) => {
      state.whatsNewData = payload
    })
})
